// Form

const serviceIdField = document.getElementById("service_id");
const serviceNameField = document.getElementById("service_name");

if (serviceIdField) {
    serviceIdField.addEventListener("change", (e) => {
        const value = e.target.value;
        if (value) {
            serviceNameField.readOnly = true;
        } else {
            serviceNameField.readOnly = false;
        }
    });
}

//const hardCostCheckbox = document.querySelector(".allow-cap");
const allowHardCostRadioCommisionType = document.querySelectorAll(
    ".js-edit-commission-type"
);
const hardCostCap = document.querySelector(".deals-form-cap");

if (hardCostCap) {
    if (allowHardCostRadioCommisionType.length) {
        function changeHandler(event) {
            if (this.value == "2") {
                hardCostCap.readOnly = false;
                if (!cap.value && cap.dataset.cap)
                    cap.value = cap.dataset.cap;
            } else {
                hardCostCap.readOnly = true;
            }
        }

        if (allowHardCostRadioCommisionType.length) {
            Array.prototype.forEach.call(
                allowHardCostRadioCommisionType,
                function (radio) {
                    radio.addEventListener("change", changeHandler);
                }
            );
        }
    }
}

const numberOfPaymentsField = document.querySelector(
    ".js-num-of-payments-deal-edit"
);
const typeRadiobutton = document.querySelectorAll(".js-edit-deal-type");
const statusOfDealField = document.querySelector(".js-status-deal-edit");
if (numberOfPaymentsField) {
    if (typeRadiobutton.length) {
        let typeValue = "Retainer";

        function changeHandler(event) {
            const statusValue = statusOfDealField.value;

            if (this.value === "2" && statusValue == "1") {
                numberOfPaymentsField.readOnly = false;
                typeValue = "2";
            } else if (this.value === "1") {
                numberOfPaymentsField.readOnly = true;
                typeValue = "1";
            }
        }

        if (statusOfDealField) {
            statusOfDealField.addEventListener("change", () => {
                const statusValue = statusOfDealField.value;

                if (typeValue === "Project" && statusValue == "1") {
                    numberOfPaymentsField.readOnly = false;
                } else if (typeValue === "Retainer") {
                    numberOfPaymentsField.readOnly = true;
                }
            });
        }

        if (typeRadiobutton.length) {
            Array.prototype.forEach.call(typeRadiobutton, function (radio) {
                radio.addEventListener("change", changeHandler);
            });
        }
    }
}

// Dynamic routes

const btnsWithRoute = document.querySelectorAll(
    "button.js-btn-deal-dynamic-route"
);

if (btnsWithRoute.length) {
    btnsWithRoute.forEach((btn) => {
        const route = btn.dataset.route;
        if (route) {
            btn.addEventListener("click", (e) => {
                e.preventDefault();

                const form = btn.closest("form");

                if (form) {

                    //form.action = route;
                    form.querySelector('input[name=action_is]').value = route;
                    form.submit();
                }
            });
        }
    });
}
